import { useSelector } from 'react-redux';

export default function useUser() {
  const { user } = useSelector(({ User }) => User);
  return user ?? {};
}
